$(function() {
  var fontSizeInitial = parseInt($('#printArea').css('font-size')),
  fontSize = fontSizeInitial;

  $('.resizeText').find('button').on('click', function(event) {
    event.preventDefault();
    if (iCreateObject.isSiteInICreateMode) {
      showNAMessage();
    } else {
      var sizer = $(this);
      if (sizer.hasClass('textDefault')) {
        fontSize = fontSizeInitial;
        resizeText(fontSize);
      } else if (sizer.hasClass('textDecrease') && fontSize > 8) {
        fontSize--;
        resizeText(fontSize);
      } else if (sizer.hasClass('textIncrease') && fontSize < 24) {
        fontSize++;
        resizeText(fontSize);
      }
    }

  });
});

function resizeText(size) {
  $('#printArea').css('font-size', size);
  $('#printArea .datatable .titlerow').css('font-size', size);
  $('.Accordion .AccordionTrigger *').css('font-size', size);
  $('.Accordion .AccordionContent').css('font-size', size);
  $('.Accordion .AccordionTitle').css('font-size', size);
  $('.icHowto').css('font-size', size);
  if ($('#uber').hasClass('interior')) {
    $.fn.matchHeight._update();
  }
}
